import { useMutation, useQuery } from '@tanstack/react-query';
import { useApi } from './useApi';
import { queryClient } from './react-query';
import { BrandingResponse } from '../../types/Branding.types';

export const useBranding = () => {
  const { makeApiRequest } = useApi();
  const { data: brandingData, isLoading: isBrandingLoading } = useQuery({
    queryKey: ['branding'],
    queryFn: () => makeApiRequest<BrandingResponse>('/branding', 'GET'),
  });

  const { mutateAsync: updateBranding } = useMutation({
    mutationFn: (data: any) => makeApiRequest('/branding', 'PUT', data),
    onSuccess: (updatedData) => {
      // Update the cache with the returned data instead of refetching
      queryClient.setQueryData(['branding'], updatedData);
    },
  });

  return {
    branding: brandingData,
    isBrandingLoading,
    updateBranding,
  };
};

export const useGetDefaultBranding = () => {
  const { makeApiRequest } = useApi();

  return useQuery({
    queryKey: ['default-branding'],
    queryFn: () => makeApiRequest('/branding/defaults', 'GET'),
  });
};

export const useDeleteBranding = () => {
  const { makeApiRequest } = useApi();

  const { mutateAsync: deleteBranding } = useMutation({
    mutationFn: () => makeApiRequest('/branding', 'DELETE'),
    onSuccess: () => {
      // Invalidate the branding query to refetch the latest data
      queryClient.invalidateQueries({ queryKey: ['branding'] });
    },
  });

  return { deleteBranding };
};
